import type { ApiClient } from './runtime/apiRuntime';
import { LinkJoinWebinarRequestDto } from './Api';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const WatchLinkApi = {
    getWebinar: (data: LinkJoinWebinarRequestDto, options?: BaseApiQueryOptions) =>
        apiQueryOptions(['watchLink', 'getWebinar', data.linkCode], (api) => api.watchLink.getWebinar(data), options),
    joinLiveWebinar: (options?: BaseApiMutationOptions<ApiClient['watchLink']['joinLiveWebinar']>) =>
        apiMutationOptions((api) => api.watchLink.joinLiveWebinar, options),
    joinOnDemandWebinar: (options?: BaseApiMutationOptions<ApiClient['watchLink']['joinOnDemandWebinar']>) =>
        apiMutationOptions((api) => api.watchLink.joinOnDemandWebinar, options)
};
